import { dataReportTrendSettingsSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconReportTrendSettingsSolid = /*#__PURE__*/createIcon(dataReportTrendSettingsSolid)
export default IconReportTrendSettingsSolid
